/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SunshineInternalDtoAdminUsersUserRole = {
    RoleAdmin: 'admin',
    RoleUser: 'user'
} as const;
export type SunshineInternalDtoAdminUsersUserRole = typeof SunshineInternalDtoAdminUsersUserRole[keyof typeof SunshineInternalDtoAdminUsersUserRole];


export function instanceOfSunshineInternalDtoAdminUsersUserRole(value: any): boolean {
    for (const key in SunshineInternalDtoAdminUsersUserRole) {
        if (Object.prototype.hasOwnProperty.call(SunshineInternalDtoAdminUsersUserRole, key)) {
            if (SunshineInternalDtoAdminUsersUserRole[key as keyof typeof SunshineInternalDtoAdminUsersUserRole] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SunshineInternalDtoAdminUsersUserRoleFromJSON(json: any): SunshineInternalDtoAdminUsersUserRole {
    return SunshineInternalDtoAdminUsersUserRoleFromJSONTyped(json, false);
}

export function SunshineInternalDtoAdminUsersUserRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): SunshineInternalDtoAdminUsersUserRole {
    return json as SunshineInternalDtoAdminUsersUserRole;
}

export function SunshineInternalDtoAdminUsersUserRoleToJSON(value?: SunshineInternalDtoAdminUsersUserRole | null): any {
    return value as any;
}

export function SunshineInternalDtoAdminUsersUserRoleToJSONTyped(value: any, ignoreDiscriminator: boolean): SunshineInternalDtoAdminUsersUserRole {
    return value as SunshineInternalDtoAdminUsersUserRole;
}

